//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    showPriceButton: {
      type: Boolean,
      default: true
    },
    showStartProgramButton: {
      type: Boolean,
      default: true
    },
    /**
     * Plan selected for user
     */
    planSelected: {
      type: String,
      default: null
    },
    /**
     * Price for the continue button
     */
    continueButtonPrice: {
      type: String,
      default: null
    },
    stepsParam: {
      type: Array,
      default: null,
      required: false
    }
  },
  computed: {
    steps () {
      return this.$t('home.howItWorks.steps')
    }
  },
  methods: {
    emitTrackAddToCart () {
      this.$emit('trackAddToCart')
    }
  }
}
